export interface WebsiteConfig {
  title: string;
  description: string;
  coverImage?: string;
  logo: string;
  /**
   * Specifying a valid BCP 47 language helps screen readers announce text properly.
   * See: https://dequeuniversity.com/rules/axe/2.2/valid-lang
   */
  lang: string;
  /**
   * blog full path, no ending slash!
   */
  siteUrl: string;
  /**
   * full url, no username
   */
  facebook?: string;
  /**
   * full url, no username
   */
  twitter?: string;
  linkedIn?: string;
  youtube?: string;
  /**
   * hide or show all email subscribe boxes
   */
  showSubscribe: boolean;
  /**
   * create a list on mailchimp and then create an embeddable signup form. this is the form action
   */
  mailchimpAction?: string;
  /**
   * this is the hidden input field name
   */
  mailchimpName?: string;
  /**
   * name and id of the mailchimp email field
   */
  mailchimpEmailFieldName?: string;
  /**
  /**
   * Meta tag for Google Webmaster Tools
   */
  googleSiteVerification?: string;
  /**
  /**
   * Appears alongside the footer, after the credits
   */
  footer?: string;
}

const config: WebsiteConfig = {
  title: 'Mapifator Blog',
  description: 'Posts, tutorials, and how-tos to create beautiful interactive maps',
  coverImage: 'img/blog-cover.png',
  logo: 'img/mapifator-logo.png',
  lang: 'en',
  siteUrl: 'https://blog.mapifator.com',
  facebook: 'https://www.facebook.com/Geoapify/',
  twitter: 'https://twitter.com/geoapify',
  linkedIn: 'https://www.linkedin.com/company/geoapify',
  youtube: "https://www.youtube.com/channel/UCuW58d2Keu1Uilnh-Pcny9w/featured",
  showSubscribe: false,
  footer: 'Learn how to create custom maps with Mapifator',
};

export default config;
